export const step2Agency = [
  {
    label: "底层资产名称",
    field: 'bottomCapitalName',
    formtype: '',
    require: false
  },
  {
    label: '所属行业',
    field: 'fundIndustry',
    formtype: 'select',
    options: [],
    require: false
  },
  {
    label: "投资金额(万元)",
    field: 'capitalInvested',
    formtype: '',
    require: false
  },
  {
    label: '投资地区',
    field: 'investProvince',
    formtype: 'select',
    options: [],
    require: false
  },
  {
    label: '投资时间',
    field: 'investTime',
    formtype: 'date',
    require: false
  },
  {
    label: '到期时间',
    field: 'investOutTime',
    formtype: 'date',
    require: false
  },
  {
    label: '投向公司自身或关联方项目情况',
    field: 'investedRelatedInfo',
    formtype: '',
    require: false
  },
  {
    label: '是否最终投向P2P、民间借贷等',
    field: 'p2p',
    formtype: 'select',
    options: [
      {
        label: "是",
        value: true
      },
      {
        label: "否",
        value: false
      }
    ],
    require: false
  },
  {
    label: '投资项目风险状况',
    field: 'investRiskInfo',
    formtype: '',
    require: false
  },
  {
    label: '其他需要说明的事项',
    field: 'extraInfo',
    formtype: '',
    require: false
  }
// {
//   label: '投资者人数',
//   field: 'investorCount',
//   formtype: "",
//   require: false
// }, {
//   label: '其中机构投资者人数',
//   field: 'institutionInvestorCount',
//   formtype: "",
//   require: false
// }, {
//   label: '其中自然投资者人数',
//   field: 'commonInvestorCount',
//   formtype: "",
//   require: false
// }, {
//   label: '投资项目',
//   field: 'investedCase',
//   formtype: "",
//   require: false
// }, {
//   label: '投资金额(万元)',
//   field: 'capitalInvested',
//   formtype: "",
//   require: false
// }, {
//   label: '投资时间',
//   field: 'investeTime',
//   formtype: "date",
//   dateRange:'month',
//   require: false
// },
// {
//   label: '拟退出时间',
//   field: 'preQuiteTime',
//   formtype: "date",
//   dateRange:'month',
//   require: false
// }, {
//   label: '投资行业',
//   field: 'fundIndustry',
//   formtype: "select",
//   options: [
//   ],
//   require: false
// }, {
//   label: '投资阶段',
//   field: 'investeStage',
//   formtype: "select",
//   options: [
//   ],
//   require: false
// }, {
//   label: '投资省份',
//   field: 'investeProvince',
//   formtype: "select",
//   options: [
//   ],
//   require: false
// }, {
//   label: '是否最终投向P2P或民间借贷',
//   field: 'investeP2p',
//   formtype: "select",
//   options: [
//     {
//       label: "是",
//       value: true
//     },
//     {
//       label: "否",
//       value: false
//     }
//   ],
//   require: false
// }, {
//   label: '投资项目风险情况',
//   field: 'investRisk',
//   formtype: "",
//   require: false
// }
];

//step3
export const step3Agency = [{
  label: '投资项目',
  field: 'investedName',
  formtype: "",
  require: false
}, {
  label: '投资时间',
  field: 'investeTime',
  formtype: "date",
  dateRange:'month',
  require: false
}, {
  label: '投资金额(万元)',
  field: 'investeCapital',
  formtype: "",
  require: false
}, {
  label: '投资行业',
  field: 'productPreIndustry',
  formtype: "select",
  options: [],
  require: false
}, {
  label: '投资省份',
  field: 'investeDistrict',
  formtype: "select",
  options: [
  ],
  require: false
}]